<form [formGroup]="formEditorContent">
    <app-hilary-ckfinder (fileChoosen)="fileChoosen($event)"></app-hilary-ckfinder>
    <angular-editor [config]="editorConfig" formControlName="contentEditor" ></angular-editor>
</form>

